import AnalyticsFilterInputs from "../../types/analytics/AnalyticsFilterInputs";
import { UsageFocusDto } from "../../types/analytics/UsageFocusDto";

const BASE = "analytics/usage/focus";

/**
 * Outcome of a Focus request. The panel needs to tell "try again shortly" apart
 * from "nothing to analyse", so the HTTP status is mapped rather than thrown.
 */
export type UsageFocusResponse =
  | { status: "OK"; focus: UsageFocusDto }
  | { status: "NO_DATA" }
  | { status: "RATE_LIMITED"; retryAfterMinutes: number }
  | { status: "UNAVAILABLE" };

class usageFocusApi {
  constructor(private accessToken: string | undefined) {}

  async generate(
    filters: AnalyticsFilterInputs,
    refresh: boolean,
  ): Promise<UsageFocusResponse> {
    try {
      const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/${BASE}?refresh=${refresh}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
          body: JSON.stringify(filters),
        },
      );

      if (response.status === 204) return { status: "NO_DATA" };
      if (response.status === 429) {
        const details = (await response.json()) as {
          retryAfterMinutes?: number;
        };
        return {
          status: "RATE_LIMITED",
          retryAfterMinutes: Math.max(1, details.retryAfterMinutes ?? 1),
        };
      }
      if (!response.ok) return { status: "UNAVAILABLE" };

      const focus = (await response.json()) as UsageFocusDto;
      return focus ? { status: "OK", focus } : { status: "UNAVAILABLE" };
    } catch {
      return { status: "UNAVAILABLE" };
    }
  }
}

export default usageFocusApi;
